import styled from 'styled-components';

export const ActionStack = styled.span`
  display: grid;
  grid-gap: 0.25em;
  justify-items: start;
`;

export default ActionStack;
